module.exports = __webpack_public_path__ + "static/20230619_022-66ab6f3a8cc8bf52376bb03782cf65e9.jpg";